<div *ngIf="shipDetailsbasicinfo">
  <ng-container *ngIf="selectedPagetab !== 'penaltyHistory'">
    <div class="poolPoint" [ngClass]="(updatePoolPointsData?.poolPointDetails?.status === 'upcomingChange' && updatePoolPointsData?.poolPointDetails?.hasPreviousChange)
      || (poolPointDetails?.status === 'upcomingChange' && poolPointDetails?.hasPreviousChange) || pointsMngPoolPointInterface.isLoader || pointsMngPenaltyInterface.isLoader ? 'poolPointUpdatedClass' : ''">
      <p class="subHeading sub-heading-s1">Pool points</p>
      <ul class="basic-info">
        <li class="pool-point-height">
          <div class="pool-point-width d-ruby">
            <div class="pr-16">
              <p class="fleet-body-b3 body-b">Pool points</p>
              <div class="Skelton-section" *ngIf="pointsMngPoolPointInterface?.isLoader">
                <div class="sektion-filter"><span class="Skelton-pp"></span></div>
              </div>
              <ng-container *ngIf="!pointsMngPoolPointInterface?.isLoader">
                <ng-container *ngIf="(updatePoolPointsData?.poolPointDetails?.hasPreviousChange === false)
                || (poolPointDetails?.hasPreviousChange === false)">
                  <p class="fleet-section-title falseCase section-title fw-700" >
                    {{updatePoolPointsData?.poolPointDetails?.currentPoolPoint ? (updatePoolPointsData?.poolPointDetails?.currentPoolPoint | negativeToBracket) :( poolPointDetails?.currentPoolPoint | negativeToBracket)}}
                  </p>
                </ng-container>
                <ng-container *ngIf="(updatePoolPointsData?.poolPointDetails?.status === 'noChange' && updatePoolPointsData?.poolPointDetails?.hasPreviousChange)
                || (poolPointDetails?.status === 'noChange' && poolPointDetails?.hasPreviousChange)">
                  <p class="fleet-section-title trueCase section-title fw-700" >
                    {{updatePoolPointsData?.poolPointDetails?.currentPoolPoint ? (updatePoolPointsData?.poolPointDetails?.currentPoolPoint | negativeToBracket) :( poolPointDetails?.currentPoolPoint | negativeToBracket)}}
                  </p>
                </ng-container>
                
                <p class="fleet-section-title section-title fw-700" *ngIf="(updatePoolPointsData?.poolPointDetails?.status === 'upcomingChange' && updatePoolPointsData?.poolPointDetails?.hasPreviousChange)
                || (poolPointDetails?.status === 'upcomingChange' && poolPointDetails?.hasPreviousChange)">
                <span class="fleet-section-title section-title fw-700">
                    {{updatePoolPointsData?.poolPointDetails?.currentPoolPoint ? (updatePoolPointsData?.poolPointDetails?.currentPoolPoint | negativeToBracket) :( poolPointDetails?.currentPoolPoint | negativeToBracket)}}
                  </span>
                  <span class="updatePoolPointData body-b">
                    <figure>
                      <img src="assets/img/infoGray.svg" alt="information">
                    </figure>
                    Pool point will change to <span class="updatepoolPoint_text">{{updatePoolPointsData?.poolPointDetails?.upComingPoolPoint ? updatePoolPointsData?.poolPointDetails?.upComingPoolPoint : poolPointDetails?.upComingPoolPoint }}</span>  
                    from <span class="updateDatePool ">{{updatePoolPointsData?.poolPointDetails?.upcomingEffectiveDate ? ( updatePoolPointsData?.poolPointDetails?.upcomingEffectiveDate | date: 'dd MMM yyyy') : (poolPointDetails?.upcomingEffectiveDate | date: 'dd MMM yyyy' ) }}</span>
                </span> 
                </p>
                <snl-tooltip position="bottom" [config]="toolTipConfig"
                  *ngIf="(updatePoolPointsData?.poolPointDetails?.status === 'pendingCalculation' && updatePoolPointsData?.poolPointDetails?.hasPreviousChange)
                  || (poolPointDetails?.status === 'pendingCalculation' && poolPointDetails?.hasPreviousChange)">
                  <span class="fleet-section-title section-title fw-700 tooltip-border-bottom">
                    {{updatePoolPointsData?.poolPointDetails?.currentPoolPoint ? (updatePoolPointsData?.poolPointDetails?.currentPoolPoint | negativeToBracket) :( poolPointDetails?.currentPoolPoint | negativeToBracket)}}
                  </span>
                  <div tooltipContent class="tooltip-padding">
                    <div class="body-b overviewToolTipFontSize">
                      <span>
                        You can modify the details <br />until
                        <span class="section-title">{{(poolPointDetails?.nextCalculationDate | date: 'dd MMM yyyy' ) ||
                          (updatePoolPointsData?.poolPointDetails?.nextCalculationDate | date: 'dd MMM yyyy')}}</span><br /> without affecting distribution.
                      </span>
                    </div>
                  </div>
                </snl-tooltip>
              </ng-container>
            </div>
             <app-edit-pool-points 
             [shipDetailsbasicinfo]="shipDetailsbasicinfo"
             [poolPointDetails]="poolPointDetails"
             (getupdatePoolPoints)="updatePoolPointsVal($event)"
             (getPoolPointLoaderEvent)="poolPointLoader()"
             (errorPoolPointLoaderEvent)="errorPoolPointLoader()"
             ></app-edit-pool-points>
          </div>
        </li>
        <li class="basic-row pool-point-height">
          <div class="penalty-width d-ruby" [ngClass]="addPenaltydetails ? 'removePenalty' : ''">
            <div class="penalty-content">
              <p class="fleet-body-b3 body-b">Penalty</p>   
                <div class="Skelton-section" *ngIf="pointsMngPenaltyInterface?.isLoader">
                  <div class="sektion-filter"><span class="Skelton-pp"></span></div>
                </div>  
                <ng-container *ngIf="!pointsMngPenaltyInterface?.isLoader">   
                  <span *ngIf="showPenalty">
                    <p class="fleet-section-title section-title fw-700"
                      *ngIf="addPenaltydetails?.penaltyPercentage || shipDetailsbasicinfo?.isPenaltyOngoing ">
                      {{(addPenaltydetails?.penaltyPercentage ? addPenaltydetails?.penaltyPercentage :
                      shipDetailsbasicinfo?.penaltyPercentage) | negativeToBracket}} %</p>
                  </span>
                  <p class="fleet-section-title section-title fw-700" *ngIf="!showPenalty">-</p>
                </ng-container>
            </div>
            <div class="addPenaltySection section-title" *ngIf="!showPenalty">      
              <figure class="penaltyBtn d-flex col-gap-8 pointsAddButtonStyle" (click)="getPenaltyEvent()">
                <img alt="add" src="/assets/img/add-icon.svg"> Add
              </figure>     
            </div>
            <div class="penaltyAdd section-title endPanelty-style" *ngIf="showPenalty">
              <div class="Skelton-section" *ngIf="pointsMngPenaltyInterface?.isLoader">
                <div class="sektion-filter"><span class="Skelton-pp"></span></div>
              </div> 
              <ng-container *ngIf="!pointsMngPenaltyInterface?.isLoader">             
                <figure class="endpenaltyBtn" (click)="endPenaltyEvent()">
                  <div class="endPenaltyWrap">
                    <img alt="add" src="/assets/img/ban.svg">
                    <span>End penalty</span>
                  </div>
                </figure>
              </ng-container>
              <div class="Skelton-section" *ngIf="pointsMngPenaltyInterface?.isLoader">
                <div class="sektion-filter"><span class="Skelton-pp"></span></div>
              </div> 
              <ng-container *ngIf="!pointsMngPenaltyInterface?.isLoader">   
                <figure class="removepenaltyBtn" (click)="removePenaltyEvent()">
                  <div class="removePenaltywrap">
                    <img alt="add" src="/assets/img/delpenalty.svg">
                    <span>
                      Remove
                    </span>
                  </div>
                </figure>
              </ng-container>
            </div>

          </div>
          <div class="view-panelty">
            <a (click)="penaltyHistory()" class="view-history-text">View penalty history</a>
          </div>
        </li>
      </ul>
    </div>
    <div class="scrubberPoint" *ngIf="isScrubberVisible?.currentScrubberUsage"  [ngClass]="(updateScrubberPointsData?.scrubberPointDetails?.status === 'upcomingChange' && updateScrubberPointsData?.scrubberPointDetails?.hasPreviousChange) || (scrubberPointDetails?.status === 'upcomingChange' && scrubberPointDetails?.hasPreviousChange) || pointsMngScrubberPointInterface.isLoader ? 'scrubberPointUpdatedClass' : ''">
      <p class="subHeading sub-heading-s1">Scrubber points</p>
      <ul class="basic-info">
        <li>
          <div class="d-ruby">
            <div class="pr-16">
              <p class="fleet-body-b3 body-b">Scrubber points</p>
              <div class="Skelton-section" *ngIf="pointsMngScrubberPointInterface?.isLoader">
                <div class="sektion-filter"><span class="Skelton-pp"></span></div>
              </div>
              <ng-container *ngIf="!pointsMngScrubberPointInterface?.isLoader">
                <ng-container *ngIf="(updateScrubberPointsData?.scrubberPointDetails?.hasPreviousChange === false)
                || (scrubberPointDetails?.hasPreviousChange === false)">
                  <p class="fleet-section-title falseCase section-title fw-700" >
                    {{updateScrubberPointsData?.scrubberPointDetails?.currentScrubberPoint ? (updateScrubberPointsData?.scrubberPointDetails?.currentScrubberPoint | negativeToBracket) :( scrubberPointDetails?.currentScrubberPoint | negativeToBracket)}}
                  </p>
                </ng-container>
                <ng-container *ngIf="(updateScrubberPointsData?.scrubberPointDetails?.status === 'noChange' && 
                updateScrubberPointsData?.scrubberPointDetails?.hasPreviousChange)
                || (scrubberPointDetails?.status === 'noChange' && scrubberPointDetails?.hasPreviousChange)">
                  <p class="fleet-section-title trueCase section-title fw-700" >
                    {{updateScrubberPointsData?.scrubberPointDetails?.currentScrubberPoint ? (updateScrubberPointsData?.scrubberPointDetails?.currentScrubberPoint | negativeToBracket) :( scrubberPointDetails?.currentScrubberPoint | negativeToBracket)}}
                  </p>
                </ng-container>
                <p class="fleet-section-title body-b1 fw-700" *ngIf="(updateScrubberPointsData?.scrubberPointDetails?.status === 'upcomingChange' && updateScrubberPointsData?.scrubberPointDetails?.hasPreviousChange)
                || (scrubberPointDetails?.status === 'upcomingChange' && scrubberPointDetails?.hasPreviousChange)">
                <span class="fleet-section-title section-title fw-700">
                    {{updateScrubberPointsData?.scrubberPointDetails?.currentScrubberPoint ? (updateScrubberPointsData?.scrubberPointDetails?.currentScrubberPoint | negativeToBracket) :( scrubberPointDetails?.currentScrubberPoint | negativeToBracket)}}
                  </span>
                <span class="updatePoolPointData body-b">
                    <figure>
                      <img src="assets/img/infoGray.svg" alt="information">
                    </figure>
                    <span class="newScrubberText">Scrubber points will change to</span><span class="updatepoolPoint_text">{{updateScrubberPointsData?.scrubberPointDetails?.upComingScrubberPoint ? (updateScrubberPointsData?.scrubberPointDetails?.upComingScrubberPoint | negativeToBracket)  : (scrubberPointDetails?.upComingScrubberPoint | negativeToBracket)}}</span> 
                    from <span class="updateDatePool ">{{updateScrubberPointsData?.scrubberPointDetails?.upcomingEffectiveDate ? ( updateScrubberPointsData?.scrubberPointDetails?.upcomingEffectiveDate | date: 'dd MMM yyyy') : (scrubberPointDetails?.upcomingEffectiveDate | date: 'dd MMM yyyy' ) }}</span>
                </span> 
                </p>
                <snl-tooltip position="bottom" [config]="toolTipConfig"
                  *ngIf="(updateScrubberPointsData?.scrubberPointDetails?.status === 'pendingCalculation' && updateScrubberPointsData?.scrubberPointDetails?.hasPreviousChange)
                  || (scrubberPointDetails?.status === 'pendingCalculation' && scrubberPointDetails?.hasPreviousChange)">
                  <span class="fleet-section-title section-title fw-700 tooltip-border-bottom">
                    {{updateScrubberPointsData?.scrubberPointDetails?.currentScrubberPoint ? (updateScrubberPointsData?.scrubberPointDetails?.currentScrubberPoint | negativeToBracket) :( scrubberPointDetails?.currentScrubberPoint | negativeToBracket)}}
                  </span>
                  <div tooltipContent class="tooltip-padding">
                    <div class="body-b overviewToolTipFontSize">
                      <span>
                        You can modify the details <br />until
                        <span class="section-title">{{(scrubberPointDetails?.nextCalculationDate | date: 'dd MMM yyyy' ) ||
                          (updateScrubberPointsData?.scrubberPointDetails?.nextCalculationDate | date: 'dd MMM yyyy')}}</span><br /> without affecting distribution.
                      </span>
                    </div>
                  </div>
                </snl-tooltip>
              </ng-container>
            </div>
              <app-edit-scrubber-points
               [shipDetailsbasicinfo]="shipDetailsbasicinfo"
               [scrubberPointDetails]="scrubberPointDetails"
               (getupdateScrubberPoints)="updateScrubberPointsVal($event)"
               (getScrubberPointLoaderEvent)="scrubberPointLoader()"
                (errorScrubberPointLoaderEvent)="errorScrubberPointLoader()"
               >
              </app-edit-scrubber-points>
          </div>
        </li>
      </ul>
    </div>
  </ng-container>
  <ng-container *ngIf="selectedPagetab === 'penaltyHistory'">
    <app-penalty-history [getVslCode]="shipDetailsbasicinfo?.vslCode"
      [penaltyHistoryPool]="shipDetailsbasicinfo?.subPool"
      [shipVslNumber]="shipDetailsbasicinfo?.vslNumber"
      [penaltyHistoryShip]="shipDetailsbasicinfo?.vslName"></app-penalty-history>
  </ng-container>
</div>
<!-- penalty modal -->
<snl-side-panel panelType="close" [headerName]="penaltyText" size="large" [(isOpen)]="openPenaltyModal">
  <div sidePanelContent class="largeSidepanelWidth">
    <app-penalty-points-sidebar *ngIf="openPenaltyFlow === 'addpenlaty' " (getPenaltyform)="penaltyValues($event)"
      (getPenaltydate)="penaltyDate($event)" (getPenaltyreason)="penaltyReason($event)"
      (calculatedPenaltyVal)="calculatedPenaltyValues($event)" 
      [currentpoolPoint]="shipDetailsbasicinfo?.poolPoint"
      [vesselActivationDate]="shipDetailsbasicinfo?.vesselActivationDate"
      [showaddPenalty]="openPenaltyFlow"></app-penalty-points-sidebar>
  </div>
  <div sidePanelFooterContent>
    <snl-button type="primary" size="large" (click)="openPenaltyModal = false;savePenalty()"
      [disabled]="!penaltyForm || !penaltyDates || !penaltyResons">Save and update</snl-button>
    <snl-button type="secondary" size="large" (click)="openPenaltyModal = false;cancelPenalty()">Cancel</snl-button>
  </div>
</snl-side-panel>
<!-- ---end penalty---- -->
<snl-side-panel panelType="close" [headerName]="endpenaltyText" size="large" [(isOpen)]="openEndPenaltyModal">
  <div sidePanelContent class="largeSidepanelWidth">
    <app-penalty-points-sidebar *ngIf="openPenaltyFlow === 'endPenalty' "
      [endPenlatypercent]="addPenaltydetails?.penaltyPercentage ? addPenaltydetails?.penaltyPercentage : shipDetailsbasicinfo?.penaltyPercentage"
      (getPenaltyEndDate)="penaltyEndDate($event)" 
      [vesselActivationDate]="shipDetailsbasicinfo?.vesselActivationDate"
      [showaddPenalty]="openPenaltyFlow"></app-penalty-points-sidebar>
  </div>
  <div sidePanelFooterContent>
    <snl-button type="primary" size="large" (click)="openEndPenaltyModal = false;saveendPenalty()"
      [disabled]="!penaltyEndDates">Save and update</snl-button>
    <snl-button type="secondary" size="large" (click)="openEndPenaltyModal = false;cancelPenalty()">Cancel</snl-button>
  </div>
</snl-side-panel>
<!-- ----remove penalty--- -->
 <ng-container *ngIf="removePenalty">
  <snl-modal (click)="removePenalty = false" [type]="'large'" [open]="removePenalty">
    <div slot="heading" class="ppLargeModalHeading"> Remove Penalty </div>
    <div slot="modalContent" class="modal-content">
      <app-penalty-points-sidebar *ngIf="(openPenaltyFlow === 'removePenalty') && removePenaltyPageLoadData" [showaddPenalty]="openPenaltyFlow"
        [endPenlatypercent]="addPenaltydetails?.penaltyPercentage ? addPenaltydetails?.penaltyPercentage : shipDetailsbasicinfo?.penaltyPercentage"
        [calculatedPoolPoints]="addPenaltydetails?.penaltyValue ? addPenaltydetails?.penaltyValue : shipDetailsbasicinfo?.penaltyValue"
        [removePenaltyDate]="removePenaltyPageLoadData?.penaltyEffectiveDate"
        [removePenaltyTime]="removePenaltyPageLoadData?.penaltyEffectiveTime" [isUsedinCalculation]="isUsedinCalculation"
        [shipName]="shipDetailsbasicinfo?.vslName" [shipPool]="shipDetailsbasicinfo?.subPool"
        [dateToDisplayInModal]="effectedMonthsArray"
        (getRemovePenaltyReason)="removePenaltyReason($event)"></app-penalty-points-sidebar>
    </div>
    <div slot="modalFooter">
      <div class="btnWrap">
        <snl-button type="secondary" size="large" (click)="removePenalty = false;cancelRemovePenalty()">Cancel</snl-button>
        <snl-button type="primary" class="errorCalc" size="large" *ngIf="isUsedinCalculation" 
        [disabled]="!removePenaltyReasons"
        [ngClass]="!removePenaltyReasons ? 'addedDisabledClass' : ''"
          (click)="removePenalty = false;penaltyRemoved()">Yes, remove</snl-button>
        <snl-button type="primary" class="errorCalc" size="large" *ngIf="!isUsedinCalculation"
          [ngClass]="!removePenaltyReasons ? 'addedDisabledClass' : ''"
          [disabled]="!removePenaltyReasons" (click)="removePenalty = false;penaltyRemoved()">Yes, remove</snl-button>
      </div>
    </div>
  </snl-modal>
</ng-container>
